import store from '../store'

const AMAZON_US='https://amzn.to/2Zg5NnN'
const AMAZON_CANADA='https://www.amazon.ca/dp/B00FPIQB3W'
const AMAZON_GB='https://www.amazon.co.uk/dp/B00FPIQB3W'
const AMAZON_GERMANY='https://www.amazon.de/dp/B00FPIQB3W'
const AMAZON_FRANCE='https://www.amazon.fr/dp/B00FPIQB3W'
const AMAZON_ITALY='https://www.amazon.it/dp/B00FPIQB3W'
const AMAZON_SPAIN='https://www.amazon.es/dp/B00FPIQB3W'



 
export function getAmazonLink() {	
	const state = store.getState()
	const geoInfo= state.geoInfo
	
	if(geoInfo){
		switch (geoInfo.country) {

		case 'CA':
			return AMAZON_CANADA

		case 'GB':
			return AMAZON_GB

		case 'DE':
			return AMAZON_GERMANY

		case 'FR':
			return AMAZON_FRANCE

		case 'IT':
			return AMAZON_ITALY


		case 'ES':
			return AMAZON_SPAIN
	

	
	default:
		return AMAZON_US




	}}
	else return AMAZON_US

}




// WEBPACK FOOTER //
// ./src/utils/getAmazonLink.js